export default __webpack_public_path__ + "static/media/primagas_logo.b370a87b.png";